import { Component, Vue, Prop, Inject, Emit } from 'vue-property-decorator';
import { INoviNsFileUploaderGlobals, FileDto } from './INoviNsFileUploaderGlobals';
import EventBus from '../../common/services/EventBus';
import FieldValidationErrors from '../../components/errors/FieldValidationErrors.vue';

declare let noviNs: INoviNsFileUploaderGlobals;

@Component({
    name: 'File',
    components: {
        FieldValidationErrors
    },
})
export default class File extends Vue {
    @Prop({ required: true })
    file!: FileDto;

    mounted() {}

    get downloadUrl() {
        return this.file ? `${noviNs.customFieldFileBaseUrl}/temp?fileName=${this.file.fullPath.split('/').pop()}` : "#";
    }
}